import React, { useContext, useState, useEffect } from "react";
import { TabContainer, TabMenu, TabItem, TabLinks } from "./GalleryElements";
import { SRLWrapper } from "simple-react-lightbox";
import CircularProgress from "@material-ui/core/CircularProgress";

import "./gallery.css";

import { GlobalContext } from "../../context/GlobalState";

const GalleryContent = () => {
  const {
    state: { photos },
  } = useContext(GlobalContext);

  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  useEffect(() => {
    if (tag === "all") {
      setFilteredImages(photos);
    } else {
      const imagesFilterArray = photos.filter(
        (image) => image.data.tag === tag
      );
      setFilteredImages(imagesFilterArray);
    }
  }, [tag, photos]);

  const handleChangeButton = (name) => {
    setTag(name);
  };

  if (!photos) {
    return null;
  }

  return (
    <>
      <TabContainer>
        <TabItem>
          <TabLinks
            active={tag === "all" ? true : false}
            onClick={() => handleChangeButton("all")}
          >
            Toate pozele
          </TabLinks>
        </TabItem>
        <TabItem>
          <TabLinks
            active={tag === "martie" ? true : false}
            onClick={() => handleChangeButton("martie")}
          >
            8 martie
          </TabLinks>
        </TabItem>
        <TabItem>
          <TabLinks
            active={tag === "teatru" ? true : false}
            onClick={() => handleChangeButton("teatru")}
          >
            Teatru
          </TabLinks>
        </TabItem>
        <TabItem>
          <TabLinks
            active={tag === "sezatoare" ? true : false}
            onClick={() => handleChangeButton("sezatoare")}
          >
            Sezatoare
          </TabLinks>
        </TabItem>
      </TabContainer>

      <div className="container">
        <SRLWrapper>
          <div className="row">
            {filteredImages.map((image) => {
              return (
                <a href={image.data.photoURL} key={image.id} rel="noopener">
                  <img src={image.data.photoURL} key={image.id} />
                </a>
              );
            })}
          </div>
        </SRLWrapper>
      </div>
    </>
  );
};

export default GalleryContent;
